import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/info.svg';

export const IconInfo = createIconComponent(Icon);
